import { http } from "../api/http";
import Utils from "../utils";

export const broadcastMessageService = {
  get,
  create,
  update,
  remove,
  getById,
  forUser,
};

async function get(requestParameters) {
  let url = `/broadcastmessage?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/broadcastmessage/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function update(requestBody) {
  let url = `/broadcastmessage/update`;

  return await http.patch(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

async function remove(requestParameters) {
  let url = `/broadcastmessage/delete?${Utils.objectToQueryString(
    requestParameters
  )}`;

  return await http.delete(url).then((response) => {
    return response;
  });
}

async function getById(requestParameters) {
  let url = `/broadcastmessage/byid?${Utils.objectToQueryString(
    requestParameters
  )}`;

  return await http.get(url).then((response) => {
    return response;
  });
}

async function forUser(requestParameters) {
  let url = `/broadcastmessage/foruser?${Utils.objectToQueryString(
    requestParameters
  )}`;

  // Same class of bug as #2583/#2660: BroadcastMessageController.GetMessagesForUser returns a
  // bare 401 when the userId query param doesn't match the JWT's own Id claim -- a mismatch
  // between the cookie's cached user object and the token, not a dead session. This component
  // mounts in Layout.jsx on EVERY authenticated page for EVERY user, so an unprotected 401 here
  // force-logs-out a user whose session is perfectly valid. See the skipAuthRedirect comment in
  // api/http.js.
  return await http.get(url, { skipAuthRedirect: true }).then((response) => {
    return response;
  });
}
